<template>
  <div class="d-flex align-center ml-4">
      <v-icon class="mr-2" :color="statusColor">mdi-whatsapp</v-icon>
      <v-chip :color="statusColor" dark small>{{ statusLabel }}</v-chip>
      <v-btn class="ml-1" color="primary" x-small text @click="$router.push('/whatsapp-atendimento')">Atendimentos</v-btn>
  </div>
</template>

<script>
import { getWhatsappGatewayStatus } from "../runtime";

export default {
  data() {
    return { status: getWhatsappGatewayStatus() };
  },
  computed: {
    statusLabel() {
      return {
        connected: "Conectado",
        connecting: "Conectando",
        auth_failed: "Token invalido",
        unreachable: "Gateway inacessivel",
        not_configured: "Nao configurado",
        network_mismatch: "Rede diferente",
        disconnected: "Desconectado"
      }[this.status] || this.status;
    },
    statusColor() {
      if (this.status === "connected") return "green";
      if (this.status === "connecting") return "orange";
      return "red";
    }
  },
  methods: {
    handleStatus(event) {
      this.status = event.detail?.status || "disconnected";
    }
  },
  created() {
    window.addEventListener("stonepro:whatsapp-gateway-status", this.handleStatus);
  },
  beforeDestroy() {
    window.removeEventListener("stonepro:whatsapp-gateway-status", this.handleStatus);
  }
};
</script>
